import { render } from "./LicenseAgreement.vue?vue&type=template&id=0f705ce2&scoped=true"
import script from "./LicenseAgreement.vue?vue&type=script&lang=js"
export * from "./LicenseAgreement.vue?vue&type=script&lang=js"

import "./LicenseAgreement.vue?vue&type=style&index=0&id=0f705ce2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Lineage-2-Vue-JS-3-Frontend/Lineage-2-Vue-JS-3-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f705ce2"]])

export default __exports__